<template>
    <div class="position-relative cursor-pointer" v-click-outside="close">
        <div class="px-2 counter-label" :class="{'slim-line': passengers.length > 1}" v-if="popup" @click="isOpen = !isOpen">
            <div v-for="(passenger, idx) in passengers" :key="idx">
                <template v-if="passenger.type === 'passenger'">
                    {{ $tc('components.passengers.quantity', passenger.quantity) }}
                </template>

                <template v-else-if="passenger.type === $constants.PASSENGER_TYPE_ADULT">
                    {{ $tc('components.passengers.quantity_adults', passenger.quantity) }}
                </template>

                <template v-else-if="passenger.type === $constants.PASSENGER_TYPE_CHILD">
                    {{ $tc('components.passengers.quantity_children', passenger.quantity) }}
                </template>

                <template v-else-if="passenger.type === $constants.PASSENGER_TYPE_CHILD_AGE_3">
                    {{ $tc('components.passengers.quantity_children', passenger.quantity) }}
                </template>
            </div>

            <div class="plus-icon">
                <font-awesome-icon icon="plus" />
            </div>
        </div>

        <div
            class="px-2 pt-2 bg-white"
            :class="{ 'position-absolute shadow border popup': popup }"
            v-show="isOpen || !popup"
        >
            <div class="d-flex align-items-center justify-content-between mb-2" v-for="(passenger, idx) in passengers" :key="idx">
                <div>
                    <template v-if="passenger.type === 'passenger'">
                        {{ $t('components.passengers.quantity_label') }}:
                    </template>

                    <template v-else-if="passenger.type === $constants.PASSENGER_TYPE_ADULT">
                        {{ $t('components.passengers.quantity_label_adults') }}:
                    </template>

                    <template v-else-if="passenger.type === $constants.PASSENGER_TYPE_CHILD">
                        {{ $t('components.passengers.quantity_label_children') }}:
                    </template>

                    <template v-else-if="passenger.type === $constants.PASSENGER_TYPE_CHILD_AGE_3">
                        {{ $t('components.passengers.quantity_label_children_max_3') }}:
                    </template>
                </div>

                <div class="ml-auto">
                    <button type="button" class="btn p-0 mt-2" @click="handleDecrease(passenger)">
                        <span class="icon-minus" :class="{ 'color': passenger.quantity > passenger.min }"></span>
                    </button>
                </div>

                <div class="text-center" style="width: 30px">
                    {{ passenger.quantity }}
                </div>

                <div>
                    <button type="button" class="btn p-0 mt-2" :disabled="maxNumber !== 0 && passengers.reduce((sum, item) => sum + item.quantity, 0) >= maxNumber" @click="handleIncrease(passenger)">
                        <span class="icon-plus"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as constants from '@/constants';

    export default {
        props: {
            passengers: {
                type: Array,
                required: true,
            },

            popup: {
                type: Boolean,
                default: true,
            },

            maxNumber: {
                type: Number,
                default: 0,
            },
        },

        data() {
            return {
                isOpen: false,

                /** @var {constants} $constants */
            };
        },

        created() {
            this.$constants = constants;
        },

        methods: {
            handleDecrease(passenger) {
                if (passenger.quantity <= passenger.min) {
                    return;
                }

                passenger.quantity--;
            },

            handleIncrease(passenger) {
                passenger.quantity++;
            },

            close() {
                this.isOpen = false;
            },
        },
    };
</script>

<style scoped>
    .popup {
        min-width: 230px;
        z-index: 5;
    }

    .counter-label {
        text-overflow: ellipsis;
        width: 90%;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
    }

    .plus-icon {
        position: absolute;
        top: 0px;
        right: 0px;
        cursor: pointer;
        opacity: 0.7;
    }

    .slim-line {
        line-height: 1rem;
    }
</style>
